     
    import { doc, setDoc } from "firebase/firestore";
    import { db } from "../utils/firebase";
    import { getAuth } from "firebase/auth";
   

     async function updateFirestoreTrophies(trophies) {
        try {
             const auth = getAuth();
            const userId = auth.currentUser?.uid;
             if (!userId) {
                return;
                }
          const userDocRef = doc(db, "users", userId);
          await setDoc(userDocRef, { trophiesWon: trophies }, { merge: true });
        } catch (error) {
          console.error("Failed to update trophies:", error);
        }
      }

      export default updateFirestoreTrophies